import { ToolboxResponse } from "../../src/components/navigation/navigation-toolbox/toolbox-response";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const linklist = `<div id="c632639" class="frame frame-default frame-type-trumpfcst_serviceslistmarginal frame-layout-0">
   <header></header>
   <div class="block block-marginal block-marginal-serviceIcons u-marginTop-55 u-marginTop45@t u-marginTop-40@m u-marginBottom-25 u-marginBottom-15@t u-marginBottom-10@m">
      <div class="marginal-headline">
         <span class="headline-small">
            Weiterführende Links
         </span>
      </div>
      <div class="block block-marginal block-marginal-serviceIcons">
         <div class="block-wrapper">
            <div class="block-content u-clearfix">
               <ux-iws-teaser-sidebar-icon>
                     <ux-icon name="globe" slot="icon"></ux-icon>
                     <a href="#" slot="title" class="ux-text-normal">
                        Finanzierung
                     </a>
               </ux-iws-teaser-sidebar-icon>
               <ux-iws-teaser-sidebar-icon>
                     <ux-icon name="tiles-big" slot="icon"></ux-icon>
                     <a href="#" slot="title" class="ux-text-normal">
                        Finanzierung
                     </a>
               </ux-iws-teaser-sidebar-icon>
               <ux-iws-teaser-sidebar-icon>
                     <ux-icon name="application-bending" slot="icon"></ux-icon>
                     <a href="#" slot="title" class="ux-text-normal">
                        Bending tools
                     </a>
               </ux-iws-teaser-sidebar-icon>
            </div>
         </div>
      </div>
   </div>
</div>
`;

const response: ToolboxResponse = {
    data: [linklist],
    message: "Success",
    status: "success",
    arguments: {
        L: "0",
        id: "21",
        locale: "de_INT",
        pageUid: "6512/",
        tx_trumpfcommon_api: {
            apiIdentifier: "navigation-toolbox",
            methodName: "toolbox",
            scope: "common",
            version: "1.0",
        },
        type: 42,
    },
};

const writeToFile = (object: ToolboxResponse) => {
    fs.writeFileSync(`${output}toolbox-linklist.json`, JSON.stringify(object));
};

writeToFile(response);
